import React, { useState, useEffect } from "react";

const ContextMenuWrapper = ({ children, menuItems = [], scrollTargetSelector = "body" }) => {
  const [menuPos, setMenuPos] = useState(null);

  const scrollToTop = () => {
    const el = document.querySelector(scrollTargetSelector);
    if (el) el.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToBottom = () => {
    const el = document.querySelector(scrollTargetSelector);
    if (el) el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
  };

  const handleContextMenu = (e) => {
    console.log("📌 右クリックイベント発火:", e.target);
    e.preventDefault();
  
    const targetElement = e.target.closest("[data-id]");
    const targetId = targetElement?.getAttribute("data-id");
  
    setMenuPos({
      x: e.pageX,
      y: e.pageY,
      targetItemId: targetId || null,
    });
  
    console.log("🎯 contextMenu targetId:", targetId);
  };

  const closeMenu = () => setMenuPos(null);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") closeMenu();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  // 統合メニュー（スクロール系含む）
  const combinedMenu = React.useMemo(() => {
    return [
      ...(typeof menuItems === "function" ? menuItems(menuPos?.targetItemId) : menuItems),
      { label: "🔼 トップへ", onClick: scrollToTop },
      { label: "🔽 最下部へ", onClick: scrollToBottom },
    ];
  }, [menuPos?.targetItemId]);  // ← menuPos の変更に合わせて再生成

  return (
    <div
      onContextMenu={handleContextMenu}
      onClick={closeMenu}
      style={{ height: "100%", width: "100%" }}
    >
      {children}

      {menuPos && (
        <div
          style={{
            position: "fixed",
            top: menuPos.y,
            left: menuPos.x,
            backgroundColor: "#222",
            color: "#fff",
            borderRadius: "6px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
            zIndex: 9999,
            fontSize: "14px",
            overflow: "hidden",
            minWidth: "150px"
          }}
        >
          {combinedMenu.map((item, idx) => (
            <div
              key={idx}
              onClick={(e) => {
                e.stopPropagation();
                item.onClick();
                closeMenu();
              }}
              style={{
                padding: "10px 14px",
                borderBottom: idx < combinedMenu.length - 1 ? "1px solid #444" : "none",
                cursor: "pointer",
                whiteSpace: "nowrap",
                backgroundColor: "#222",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#333")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#222")}
              onContextMenu={(e) => e.preventDefault()}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ContextMenuWrapper;
